export default [
  {
    header: 'Tasks',
  },
  {
    title: 'Risks',
    icon: 'ActivityIcon',
    route: 'organization-process-list',
    moduleKey: 'risks',
    children: [
      {
        title: 'List',
        route: 'organization-process-list',
        moduleKey: 'risks',
      },
      {
        title: 'Controls',
        route: 'organization-control-list',
        moduleKey: 'controls',
      },
      {
        title: 'Behaviours',
        route: 'organization-behaviour-list',
        moduleKey: 'task-behaviours',
      },
      // {
      //   title: 'Crimes',
      //   route: 'organization-crime-list',
      // },
      // {
      //   title: 'Documents',
      //   route: 'organization-document-list',
      // },
    ],
  },
  {
    title: 'Calendar',
    icon: 'CalendarIcon',
    route: 'apps-calendar',
    moduleKey: 'calendar',
    children: [
      {
        title: 'Calendar',
        route: 'apps-calendar',
        moduleKey: 'calendar',
      },
      {
        title: 'Pending Confirmations',
        route: 'organization-pending-confirmations',
        moduleKey: 'pending-confirmations',
      },
    ]
  },
  {
    title: 'Confirmation Planning',
    route: 'organization-confirmation-planning-list',
    icon: 'ClipboardIcon',
    moduleKey: 'confirmation-planning',
  },
]
